import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IConfirmUserPayload } from '@app-store/slices/users/confirmUser'
import { Action } from 'redux'

interface TaskAction extends Action {
    payload: IConfirmUserPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.users.confirmUser

function* confirmUserSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/users/confirm-user/${payload.email}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB) {
                payload?.sagaCB?.onSuccess(response.result)
            }
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* confirmUserSaga(): any {
    yield takeLatest<TaskAction>(onRequest, confirmUserSagaTask)
}

export default confirmUserSaga
